import { Injectable } from '@angular/core';
import { WindorefService } from '../window/windoref.service';

@Injectable({
  providedIn: 'root'
})
export class MarketingPixelsService {

  constructor(    
    private _winRef: WindorefService,
    ) { }

  async findPixel(pixel: any): Promise<any>{
    let pixelTag: string = pixel[0].tag;
    pixel = pixelTag.split("src=");
    pixel = pixel[1].split("\"");
    const tag = this._winRef.getNativeWindow().document.createElement('img');
    tag.src = pixel[1];
    tag.width = 1;
    tag.height = 1; 
    await this._winRef.getNativeWindow().document.getElementsByTagName('body')[0].appendChild(tag);
  }

}
